import classnames from 'classnames/bind';
import { FC } from 'react';
import { ApprovalGroupProps } from '../../types';
import { ApprovalGroupItem } from '../ApprovalGroupItem';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export const ApprovalGroup: FC<ApprovalGroupProps> = ({ groups }) => {
  const isShowInformationTag = !!groups && groups.length > 1;

  if (!groups) {
    return null;
  }
  return (
    <div className={cx('container')}>
      {groups.map((group) => (
        <ApprovalGroupItem
          key={group.name}
          groupItem={group}
          isShowInformationTag={isShowInformationTag}
        />
      ))}
    </div>
  );
};
